const RESERVATION_PAGE_BACK_ROUTE = 'reservationPageBackRoute';

export const setReservationPageBackRoute = (path) => sessionStorage.setItem(RESERVATION_PAGE_BACK_ROUTE, path);
export const getReservationPageBackRoute = () => sessionStorage.getItem(RESERVATION_PAGE_BACK_ROUTE);
export const clearReservationPageBackRoute = () => sessionStorage.removeItem(RESERVATION_PAGE_BACK_ROUTE);